import React from "react";
import { useGlobalValue } from "../../state/GlobalProvider";
import styles from "./LinkButton.module.sass";

const LinkButton = props => {
  const {
    label,
    to,
    onClick,
    className,
    openNewTab = false
  } = props;
  const {
    history
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement("button", {
    className: `${styles["link"]} ${className || ""}`,
    onClick: e => {
      onClick && onClick(e);

      if (to) {
        e.preventDefault();
        e.stopPropagation();

        if (e.metaKey || openNewTab) {
          window.open(to, "_blank");
        } else {
          history.push(to);
        }
      }
    }
  }, /*#__PURE__*/React.createElement("small", {
    className: `${styles["link-color"]}`
  }, label));
};

export default LinkButton;